module.exports = __webpack_public_path__ + "img/login_img_1.d6a6d791.png";